import React, { useEffect, useState } from "react";
import axios from "axios";
import cookie from "js-cookie";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import { confirmAlert } from "react-confirm-alert";
import DataTableExtensions from "react-data-table-component-extensions";
import DataTable from "react-data-table-component";
import Loader from "../../components/shared/Loader";
import { updateMeta } from "../../store/actions/metaAction";
import { useDispatch } from "react-redux";
import { useRef } from "react";
import { useMemo } from "react";
import { Col, Container, Row } from "reactstrap";

const ContactIndex = () => {
	const [hiringRequests, setHiringRequests] = useState([]);
	const [loading, setLoading] = useState(true);
	const [selectedHiringRequest, setSelectedHiringRequest] = useState({});
	const dispatch = useDispatch();
	const formInfo = useRef(null);

	useEffect(() => {
		onStart();
		formInfo.current.style.display = "none";
	}, []);

	const onStart = () => {
		dispatch(
			updateMeta({
				title: "جميع الرسائل المرسلة من الزوار",
				breadcrumb: "اتصل بنا",
				button: {
					show: false,
					text: null,
					link: null,
				},
			})
		);

		axios
			.get(`${process.env.REACT_APP_API_URL}/requests`, {
				headers: {
					Authorization: `Bearer ${cookie.get("token")}`,
					Accept: "application/json",
				},
			})
			.then(function (response) {
				setHiringRequests(response.data.data.requests);
				setLoading(false);
			})
			.catch(function (error) {
				toast.error("خطأ، برجاء المحاولة لاحقا!");
			});
	};
	const renderView = order => {
		setLoading(true);
		formInfo.current.style.display = "flex";
		setSelectedHiringRequest({ ...order });
	};

	const renderSelectedContact = useMemo(() => {
		const jobRolesArabic = {
			lawyer: "محامى",
			trainer: "متدرب",
			admin: "إدارى",
			consultant: "مستشار",
		};
		const qualification = {
			diploma: "دبلوم",
			highschool: "ثانوي",
			bachelor: "بكالوريوس",
			master: "ماجستير",
			phd: "دكتوراه",
		};

		setLoading(false);
		return (
			<Container
				style={{
					background: "white",
					paddingTop: "2rem",
					paddingBottom: "2rem",
					borderRadius: "10px",
					maxHeight: "90vh",
					overflow: "auto",
				}}
			>
				<div className="row">
					<div className="col-md-12">
						<div className="form-item">
							<label htmlFor="name">الاسم</label>
							<input
								type="text"
								id="name"
								disabled
								value={selectedHiringRequest?.name}
							/>
						</div>
						{/* <div className="form-item">
								<label htmlFor="phone"> اسم الشريكة </label>
								<input
									type="text"
									id="phone"
									disabled
									value={selectedHiringRequest?.others?.companyName}
								/>
							</div> */}
						{!!selectedHiringRequest?.email && (
							<div className="form-item">
								<label htmlFor="email">البريد الالكتروني</label>
								<input
									type="email"
									id="email"
									disabled
									value={selectedHiringRequest?.email}
								/>
							</div>
						)}
						{!!selectedHiringRequest?.phone && (
							<div className="form-item">
								<label htmlFor="phone">رقم الهاتف</label>
								<input
									type="text"
									id="phone"
									disabled
									value={selectedHiringRequest?.phone}
								/>
							</div>
						)}
						{!!selectedHiringRequest?.gender && (
							<div className="form-item">
								<label htmlFor="gender"> النوع </label>
								<input
									type="text"
									id="gender"
									disabled
									value={
										selectedHiringRequest?.gender === "male" ? "ذكر" : "انثى"
									}
								/>
							</div>
						)}
						{!!selectedHiringRequest?.ageRange && (
							<div className="form-item">
								<label htmlFor="ageRange"> الفئة العمرية </label>
								<input
									type="text"
									id="ageRange"
									disabled
									value={selectedHiringRequest?.ageRange}
								/>
							</div>
						)}
						{!!selectedHiringRequest?.jobRole && (
							<div className="form-item">
								<label htmlFor="jobRole"> الوظيفة </label>
								<input
									type="text"
									id="jobRole"
									disabled
									value={jobRolesArabic[selectedHiringRequest.jobRole]}
								/>
							</div>
						)}
						{!!selectedHiringRequest?.qualification && (
							<div className="form-item">
								<label htmlFor="qualification"> المؤهل </label>
								<input
									type="text"
									id="qualification"
									disabled
									value={qualification[selectedHiringRequest.qualification]}
								/>
							</div>
						)}
						{!!selectedHiringRequest?.lastName?.project && (
							<div className="form-item">
								<label htmlFor="phone"> نوع الخدمة</label>
								<input
									type="text"
									id="phone"
									disabled
									value={selectedHiringRequest?.lastName?.project}
									companyName
								/>
							</div>
						)}
						{!!selectedHiringRequest?.lastName?.file && (
							<div className="form-item">
								<label htmlFor="phone" className="w-100">
									{" "}
									الملف المرفق
								</label>

								<a
									href={`${process.env.REACT_APP_MAIN_URL}${selectedHiringRequest?.lastName?.file}`}
									target="_blank"
								>
									عرض الملف
								</a>
							</div>
						)}
						<div className="form-item">
							<label htmlFor="phone">الخبرات</label>
							<textarea
								id="message"
								cols="25"
								rows="5"
								value={selectedHiringRequest?.experience}
								readOnly={true}
								disabled
								style={{ resize: "none" }}
							/>
						</div>
					</div>
				</div>

				<button
					className="bt bt-danger bt-sm"
					onClick={() => (formInfo.current.style.display = "none")}
				>
					رجوع الي القائمة الطلبات
				</button>
			</Container>
		);
	}, [selectedHiringRequest]);
	const columns = [
		// {
		// 	name: "ID",
		// 	selector: "id",
		// 	sortable: true,
		// },
		{
			name: "الاسم",
			selector: "name",
			sortable: true,
		},
		{
			name: "البريد الالكتروني",
			selector: "email",
			sortable: true,
		},
		{
			name: "رقم الهاتف",
			selector: "phone",
			sortable: true,
		},
		{
			name: "settings",
			selector: "settings",
			cell: row => (
				<ul className="list-inline settingsList">
					<li className="list-inline-item">
						{/* <Link className="bt bt-success bt-sm" to={`/orders/show/${row.id}`}> */}
						<d className="bt bt-success bt-sm" onClick={() => renderView(row)}>
							<i className="fas fa-eye"></i>
						</d>
						{/* </Link> */}
					</li>
					<li className="list-inline-item">
						<button
							className="bt bt-danger bt-sm"
							onClick={() => handleConfrimDelete(row.id)}
						>
							<i className="fas fa-trash"></i>
						</button>
					</li>
				</ul>
			),
		},
	];

	const handleConfrimDelete = requestId => {
		confirmAlert({
			title: "تأكيد الحذف",
			message: "هل أنت متأكد من رغبتك في الحذف؟",
			buttons: [
				{
					label: "نعم",
					onClick: () => deleteContact(requestId),
				},
				{
					label: "لا",
					onClick: () => console.log("No"),
				},
			],
		});
	};

	const deleteContact = requestId => {
		axios
			.delete(`${process.env.REACT_APP_API_URL}/requests/${requestId}`, {
				headers: {
					Authorization: `Bearer ${cookie.get("token")}`,
					Accept: "application/json",
				},
			})
			.then(function (response) {
				onStart();
			})
			.catch(function (error) {
				toast.error("خطأ، برجاء المحاولة لاحقا!");
			});
	};

	return (
		<section>
			{loading && <Loader />}
			<div
				className="contactModal"
				style={{
					zIndex: "100000000",
					background: "#141414b5",
					position: "fixed",
					width: "85%",
					height: "100vh",
					top: "0",
					display: "flex",
					justifyContent: "center",
					alignItems: "center",
					left: "0",
					padding: "3rem",
					paddingTop: "1.3rem",
				}}
				ref={formInfo}
			>
				{renderSelectedContact}
			</div>
			<div className="datatable">
				<DataTableExtensions columns={columns} data={hiringRequests}>
					<DataTable
						noHeader
						defaultSortField="id"
						defaultSortAsc={false}
						pagination
						highlightOnHover
						direction="rtl"
						striped
					/>
				</DataTableExtensions>
			</div>
		</section>
	);
};

export default ContactIndex;
